// Segment.com

export function segmentIdentify(user) {
	analytics.identify(user.uuid, {
		name: user.first_name + ' ' + user.last_name,
		email: user.email
	})
}

export function segmentTrack(action, payload) {
	analytics.track(action, {
		...payload
	})
}

export function segmentPage(title, path, browser_height, browser_width) {
	analytics.page({
		title: title,
		path: path,
		browser_height: browser_height,
		browser_width: browser_width
	})
}
